module.exports = __webpack_public_path__ + "img/xp_icon_wq03.png";